module.exports = __webpack_public_path__ + "img/logo_rnf.5a863b9d.png";